import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, checked } = useAuth();
  const location = useLocation();

  if (!checked) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center text-[#C0C0C0]">Loading…</div>
    );
  }
  if (!user) {
    const target = adminOnly ? '/admin/login' : '/login';
    return <Navigate to={target} state={{ from: location.pathname }} replace />;
  }
  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  return children;
}
